module.exports = "https://cdn2-fs.clearscore.com/flux/images/c7f02d4cc5a57ba34fa943b7ad4f946e.jpg";